import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { CustomerModel } from 'src/app/models/customer.model';
import { AuthService } from 'src/app/services/auth.service';
import { MyProfileService } from '../../../services/my-profile.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-menu-customer',
  templateUrl: './menu-customer.component.html',
  styleUrls: ['./menu-customer.component.scss']
})
export class MenuCustomerComponent implements OnInit {
  public customer?: CustomerModel;
  public show: boolean = false;
  public comissionerMode?: boolean = false;
  public enableFacialRecognition = environment.enableFacialRecognition;
  @Input() hasComissioner: boolean = false;
  @Output() logout: EventEmitter<any> = new EventEmitter();
  @Output() sendModeComissioner: EventEmitter<any> = new EventEmitter();
  constructor(
    private authService: AuthService,
    private myProfileService: MyProfileService
  ) { }

  ngOnInit(): void {
    this.customer = this.authService.getCustomer();
    this.comissionerMode = this.authService.getCustomer().modeComissioner;
    this.myProfileService.getComissioner().subscribe((res: any) => {
      this.comissionerMode = res;
    });

    if (this.authService.getCustomer() != null && this.authService.getCustomer().modeComissioner != null && this.authService.getCustomer().modeComissioner == true) {
      this.comissionerMode = true;
    }

    if (this.authService.getCustomer() != null && this.authService.getCustomer().modeComissioner != null && this.authService.getCustomer().modeComissioner == true) {
      this.comissionerMode = true;
    }



    if (this.authService.getCustomer() != null && this.authService.getCustomer().comissionerId != null && this.authService.getCustomer().comissionerId !== '') {
      this.hasComissioner = true;
    }


  }

  public toggle(): void {
    this.show = !this.show;
  }

  public modeComissioner() {
    this.authService.defineModeComissioner(this.comissionerMode as boolean);
    if (this.authService.getCustomer().modeComissioner == false) {
      this.comissionerMode = true;
      window.open("/", "_blank")    
      this.myProfileService.defineModeComissioner(this.comissionerMode as boolean);
      this.authService.defineModeComissioner(this.comissionerMode as boolean);
    } else {
      this.comissionerMode = false;
      this.myProfileService.defineModeComissioner(this.comissionerMode as boolean);

      this.authService.defineModeComissioner(this.comissionerMode as boolean);
    }
  }




  public logOut(): void {
    this.toggle();
    this.myProfileService.defineModeComissioner(false);
    this.authService.logout();
    this.logout.emit('logout');
  }
}
